import TimeInput from "./TimeInput";
import DateSelect from "./DateSelect";

export const TimeInputGroup = ({ label, day, time, onDayChange, onTimeChange, disabled, translations}) => (
    <div className="flex items-center gap-2">
      <span className="w-16">{label}</span>
      <DateSelect 
        value={day}
        onChange={onDayChange}
        disabled={disabled}
      />
      <span>{translations("form.schedule.at")}</span>
      <TimeInput
        value={disabled ? "-" : time}
        onChange={onTimeChange}
        disabled={disabled}
      />
    </div>
  );